"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentItem = void 0;
/**
 * Class representing Content returned from the Content Delivery Service.
 * The body property will contain the properties specified by the JSON schema content type.
 * Any linked content items will be included inline in the body.
 */
var ContentItem = /** @class */ (function () {
    function ContentItem() {
    }
    /**
     * Returns a plain JSON version of the content body, removing helper properties and functions.
     * This should be used if your application needs to serialize the content body, e.g. in an API response.
     */
    ContentItem.prototype.toJSON = function () {
        return JSON.parse(JSON.stringify(this.body));
    };
    return ContentItem;
}());
exports.ContentItem = ContentItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudEl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL2NvbnRlbnQvbW9kZWwvQ29udGVudEl0ZW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUE7Ozs7R0FJRztBQUNIO0lBQUE7SUFjQSxDQUFDO0lBUEM7OztPQUdHO0lBQ0gsNEJBQU0sR0FBTjtRQUNFLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0lBQy9DLENBQUM7SUFDSCxrQkFBQztBQUFELENBQUMsQUFkRCxJQWNDO0FBZFksa0NBQVcifQ==